import React, { useState } from "react";
import ModernNewsDashboard from "./ModernNewsDashboard";
import ModernNewsDetails from "./ModernNewsDetails";

const News = () => {
  const [selectedNews, setSelectedNews] = useState(null);

  return selectedNews ? (
    <ModernNewsDetails
      news={selectedNews}
      onBack={() => setSelectedNews(null)}
      onSelectNews={setSelectedNews}
    />
  ) : (
    <ModernNewsDashboard onSelectNews={setSelectedNews} />
  );
};

export default News;
